import React from 'react';
import PropTypes from 'prop-types';

class CountItem extends React.Component {
	constructor() {
		super();
		this.state = {
			isHovered: false
		};
		this.handleHover = this.handleHover.bind(this);
	}

	handleHover() {
		this.setState(prevState => ({
			isHovered: !prevState.isHovered
		}));
	}

	render() {
		const {
			label,
			count,
			link,
			textColor,
			className,
			countTextSize,
			labelTextSize,
			animate,
			rounded,
			name,
			trackGa
		} = this.props;

		const containerName = className.toLowerCase().replace(/_/g, '-');
		const suffix = '+';
		let countString = count;

		if (rounded) {
			countString = countString.concat(suffix);
		}

		const itemDisplay = (
			<div className={textColor}>
				<div className={`item-count ${countTextSize}`}>
					{countString}
				</div>
				<div className={`item-label ddc-font-size-${labelTextSize}`}>
					{label}
				</div>
			</div>
		);

		const trackEvent = () => {
			trackGa({
				element: name,
				result: `Navigated to ${link}`,
				elementCta: label
			});
		};

		const utilityClass =
			'transition-property-transform transition-timing-function-standard transition-duration-lg';
		const hoverClass = this.state.isHovered
			? `${utilityClass} scale-110`
			: `${utilityClass} scale-100`;

		return count !== '0' ? (
			<div
				className={`count-item p-2 ${
					animate ? `animate ${hoverClass}` : ' '
				} item-${containerName}`}
				onClick={() => {
					trackEvent();
				}}
				onMouseEnter={this.handleHover}
				onMouseLeave={this.handleHover}
				role="presentation"
			>
				{link ? (
					<a className="item-link text-no-decoration" href={link}>
						{itemDisplay}
					</a>
				) : (
					itemDisplay
				)}
			</div>
		) : null;
	}
}

CountItem.propTypes = {
	label: PropTypes.string.isRequired,
	count: PropTypes.string.isRequired,
	link: PropTypes.string,
	textColor: PropTypes.string.isRequired,
	className: PropTypes.string.isRequired,
	countTextSize: PropTypes.string.isRequired,
	labelTextSize: PropTypes.string.isRequired,
	animate: PropTypes.bool.isRequired,
	rounded: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	trackGa: PropTypes.func.isRequired
};

CountItem.defaultProps = {
	link: null
};

export default CountItem;



// WEBPACK FOOTER //
// ./src/components/CountItem.jsx